import ReactDOM from 'react-dom';
const globalReactDOM = window.ReactDOM;
export default globalReactDOM ? globalReactDOM : ReactDOM;
export const {
  createPortal,
  findDOMNode,
  flushSync,
  hydrate,
  render,
  unmountComponentAtNode,
  unstable_batchedUpdates,
  unstable_createPortal,
  unstable_renderSubtreeIntoContainer,
  version 
} = globalReactDOM ? globalReactDOM : ReactDOM;
